export enum TestTaskType {
  CODILITY = 'CODILITY',
  QUIZ = 'QUIZ',
  INTERNAL = 'INTERNAL',
  CUSTOM = 'CUSTOM',
  HACKER_RANK = 'HACKER_RANK',
}

export const TestTaskTypeToText = {
  [TestTaskType.CODILITY]: 'Coding test',
  [TestTaskType.HACKER_RANK]: 'Coding test',
  [TestTaskType.QUIZ]: 'Knowledge quiz',
  [TestTaskType.INTERNAL]: 'Internal test',
  [TestTaskType.CUSTOM]:
    'Project-specific coding test for some of our special opportunities',
};

export enum TEST_TASK_STATUS {
  SENT = 'Sent',
  DONE = 'Done',
  FAILED = 'Failed',
  PASSED = 'Passed',
  TODO = 'Todo',
  // PLP-2482: mirrors backend TestTaskStatus.SKIPPED. Response-only, never persisted.
  SKIPPED = 'Skipped',
}

export const TEST_TASK_STATUS_REFRESH_TIME = 15;

// A passed test task counts as valid only if its result is within this many years (PLP-2482, mirrors backend TT_VALIDITY_YEARS).
export const TT_VALIDITY_YEARS = 3;

export const simulatedTTString = 'https://simulation-link.com/';

export const SELECT_TECHNOLOGY_ERROR_MESSAGE = 'Please select technology first';

export enum TEST_TASK_ORIGINS {
  LAUNCHPOD = 'LAUNCHPOD',
  DATAWAREHOUSE = 'DATAWAREHOUSE',
}

export enum HackerRankTestStatus {
  Invited = -1,
  Started = 0,
  Evaluated = 7,
}
